import ListSection from '@/components/List/ListSection'
import NavBar from '@/components/NavBar'
import Page from '@/components/Page'
import { createFileRoute } from '@tanstack/react-router'
import { useTitle } from 'react-use'
import FeaturePreviewItem from './-components/FeaturePreviewItem'
import FeaturePreviewVideo from './-components/FeaturePreviewVideo'
import styles from './index.module.css'

export const Route = createFileRoute('/experiment/')({
	component: ExperimentPage,
})

function ExperimentPage() {
	useTitle(`🧪 实验室 - 即刻`)

	return (
		<Page header={<NavBar title={<>🧪 实验室</>} />} className={styles.page}>
			<div className={styles.content}>
				<ListSection title="实验功能">
					<FeaturePreviewItem
						feature="isActionTextBlurTransitionEffectEnabled"
						title="动态、评论数值模糊变化"
						preview={
							<FeaturePreviewVideo src="https://cdnv2.ruguoapp.com/FqRQw7i6z-v_Ktfguh8rUVNu8j76.mp4" />
						}
					/>
					<FeaturePreviewItem
						feature="isPostDetailSideSheetEnabled"
						title="动态详情侧栏"
						preview={
							<FeaturePreviewVideo src="https://cdnv2.ruguoapp.com/Fl-0m0uP6lggzjSeILlP3GaPI09O.mp4" />
						}
					/>
				</ListSection>
			</div>
		</Page>
	)
}
